/**
 * Unified agent state badge (Draft / Private / Public / Archived).
 */

import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import type { StudioAgentState } from '@/types/aiStudioAgent';

const STATE_CLASSES: Record<StudioAgentState, string> = {
  draft: 'border-[var(--color-border)] text-[var(--color-surface-text-secondary)]',
  private: 'border-[var(--color-info)] text-[var(--color-info)]',
  public: 'border-[var(--color-success)] text-[var(--color-success)]',
  archived: 'border-[var(--color-warning)] text-[var(--color-warning)]',
};

interface AgentStateBadgeProps {
  state: StudioAgentState;
}

export const AgentStateBadge: React.FC<AgentStateBadgeProps> = ({ state }) => {
  const { t } = useLanguage();
  return (
    <span
      className={`inline-block rounded-full border px-2 py-0.5 text-base ${STATE_CLASSES[state] ?? STATE_CLASSES.draft}`}
    >
      {t(`aiStudio.agents.state.${state}`)}
    </span>
  );
};
